import React, { useEffect, useState } from 'react';
import { Button, Dialog, SearchInput } from "evergreen-ui";
import { TableExport } from "tableexport";
import { DatePicker, Table } from "antd";
import { useListVals } from "../../Firebase/databaseHooks";
import { getDatabase, ref } from "firebase/database";
import Firebase from "../../Firebase/Firebase";
import moment from "moment";

var db = getDatabase(Firebase);
const { RangePicker } = DatePicker;
const Ranking = () => {
	const columns = [
		{
			title: 'Name',
			dataIndex: 'name',
			key: 'name',
			responsive: ["sm"],
			sorter: (a, b) => a.name && a.name.localeCompare(b.name)
		},
		{
			title: 'Quizzes Done',
			dataIndex: 'quizzes',
			key: 'quizzes',
			sorter: (a, b) => parseFloat(b.quizzes) - parseFloat(a.quizzes)
		},
		{
			title: 'Overall Grades',
			dataIndex: 'grade',
			key: 'grade',
			sorter: (a, b) => parseFloat(b.grade) - parseFloat(a.grade)
		}
	];

	const [dataArray, setDataArray] = useState([]);
	const [eventsData, setEventsData] = useState([]);
	const [quizGrades, loading] = useListVals(ref(db, "talmidsdb/quizCompletions"));
	const [Points] = useListVals(ref(db, "talmidsdb/points"));
	const [gradeArray, setGradeArray] = useState([]);
	const [userArray] = useListVals(ref(db, "talmidsdb/users"));
	const [showPicker, setShowPicker] = useState(false);
	const [period, setPeriod] = useState([]);

	function getSum(total, num) {
		return (total + parseInt(num.grade));
	}

	useEffect(() => {
		if (quizGrades) {
			setGradeArray(quizGrades);
			gradeArray.map((grade) => {
				var txt = grade.grade;
				var numb = String(txt).match(/\d/g).join('');
				grade.grade = parseFloat(numb);
			});
			process(gradeArray);
		}
	}, [gradeArray, quizGrades, userArray]);

	const process = (forArray) => {
		// get the grades of the known users first : those whose IDs are in the system
		var tempArray = []
		userArray.map((user, index) => {
			var gradesForUser = forArray.filter(x => x.userID === user.id);

			if (gradesForUser.length > 0) {
				tempArray.push({
					key: index + 1,
					grade: ((gradesForUser.reduce(getSum, 0)) / (gradesForUser.length)).toFixed(1),
					name: user.firstname + " " + user.surname,
					quizzes: gradesForUser.length
				});
			}
		});

		var unknownArray = [];
		forArray.map((grade) => {
			if ((userArray.find(x => x.id === grade.userID) === undefined)) {
				unknownArray.push(grade);
			}
		});
		var unknownObject = {}
		unknownArray.map((item) => {
			unknownObject[item.userID] = unknownArray.filter(x => x.userID === item.userID);
		});

		Object.values(unknownObject).map((value, index) => {
			tempArray.push({
				key: index + 1,
				grade: ((value.reduce(getSum, 0)) / (value.length)).toFixed(1),
				name: "Unknown User " + (index + 1),
				quizzes: value.length
			});
		});

		tempArray.map((value, index) => {
			value.key = index + 1;
		});

		setEventsData([...tempArray]);
		setDataArray([...tempArray]);
	}

	function exportXL(tab) {
		var table = tab;
		var exportData = table.getExportData();
		console.log(exportData);
		var csv = exportData?.rankingTable?.csv;
		table.export2file(csv?.data, csv?.mimeType, csv?.filename, csv?.fileExtension, csv?.merges, csv?.RTL, csv?.sheetname);
	}

	const handleSearch = searchText => {
		searchText = searchText.toLowerCase();
		const filteredEvents = dataArray.filter(({ name, time }) => {
			name = name && name.toLowerCase();
			time = time && time.toLowerCase();
			return (name && name.includes(searchText)) || (time && time.includes(searchText));
		});
		setEventsData(filteredEvents);
	};
	function onDateChange(date, dateString) {
		setPeriod(dateString);
	}

	function filterPeriod() {
		var startTime = moment(period[0], 'YYYY-MM-DD');
		var endTime = moment(period[1], 'YYYY-MM-DD');
		var withinPeriodArray = [];
		gradeArray.map((inter) => {
			var interTime = moment(inter.timestamp, "YYYY-MM-DDTh:mm:ss");
			if (moment(interTime).isBetween(startTime, endTime)) {
				withinPeriodArray.push(inter);
			}
		});
		process(withinPeriodArray);
		setShowPicker(false)
	}

	return (
		<>
			<div>
				<Dialog
					isShown={showPicker}
					title="Select Period"
					onCloseComplete={() => { setShowPicker(false) }}
					onConfirm={() => {
						filterPeriod();
					}}
				>
					<RangePicker style={{ width: "100%" }} onChange={onDateChange} />
				</Dialog>
				<div style={{ marginBottom: 10 }} className="float-right">
					<SearchInput placeholder="Search Users" className="w-100 mx-1" width={window.innerWidth - 1000} onChange={e => handleSearch(e.target.value)} />
					<Button appearance="primary" className="mx-1" onClick={() => {
						setShowPicker(true);
					}}>
						Filter Period
					</Button>
					<Button appearance="primary" className="mx-1" onClick={() => {
						exportXL(TableExport(document.getElementById("rankingTable"), {
							filename: "OverallRanking",
							exportButtons: false,
							sheetname: "Ranking",
						}));
					}}>
						Print
					</Button>
				</div>
				<Table style={{ overflow: "auto" }} loading={loading}
					pagination={{ defaultPageSize: 20, showSizeChanger: true, pageSizeOptions: ['20', '50', '100'] }}
					id={"rankingTable"} dataSource={eventsData} columns={columns} />
			</div>
		</>
	)
}

export default Ranking;
